export default "__VITE_ASSET__4698048c__"